export default __webpack_public_path__ + "static/media/confirmation2.c872a859.jpg";